module.exports = __webpack_public_path__ + "public/images/slider/speaker-4-icon.794c95267a38a06cdae54b4e1a187d79.png";